import { hashString128 } from '@w/utils'
import { ulid as id } from '@w/utils'

export const toOtelTraceId = (ulid?: string) => hashString128(ulid || id())
export const toOtelSpanId = (ulid?: string) => hashString128(ulid || id()).substring(0, 16)

export function toRequestId(data: {
  traceId?: string
  requestId?: string
}): string {
  const uid = data.requestId ?? data.traceId
  return toOtelTraceId(uid)
}

export interface OtelResource {
  name: string
  overrideName?: string // introduced as temporary solution to support older name in grafana
  version: string
  env: string
}
